require('./menu-item-prices/menu-item-prices.scss');
var BaseViews = require('../../base');
var MenuItemPrices = require('./menu-item-prices');
var Obscura = require('backbone.obscura');

var PricesLocationTableSelectedTitle = Marionette.ItemView.extend({
  initialize: function (options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              title: 'title'
          }
      );
  },
  className: 'prices-location-table-selected-title',
  template: function () {
      return '';
  },
  render: function() {
      this.$el.html(this.options.title);
  }
});


var OtherPricesItemView = BaseViews.LayoutView.extend({
  initialize: function (options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              title: 'title'
          }
      );
  },
  events: {
      'click .fmcy-other-location-name': '_otherLocationNameOnClick'
  },
  regions: {
    tablePricesCheckRegion : '.fmcy-menu-item-table-prices-check-region'
  },
  tagName: 'tr',
  template: require('./menu-item-prices-location-table/other-prices-item-view.html'),
  serializeData: function () {
    return {
      locationName: this.model.get('name')
    }
  },
  _renderPricesTableCheck: function (options) {
    this._tablePricesCheck = new MenuItemPrices({
      menuItemModel: this.options.menuItemModel,
      collection: this.options.variantCollection,
      locations: this.options.locations,
      onSale: this.options.menuItemModel.isOnSale(),
      appChannel: this.options.appChannel,
      filterLocation: this.model.get('slug'),
      selected: options.selected,
      menuItemPriceLayoutSinglePrice: this.options.menuItemPriceLayoutSinglePrice,
      align: this.options.align,
      size: this.options.size,
      style: 'checks',
      theme: this.options.theme,
      variantShowInStockIfAtAnyLocation: false
    });

    this.tablePricesCheckRegion.show(this._tablePricesCheck);
  },
  onRender: function() {
      if (this.model == this.options.selectedLocationModel) {
        this._selectedLocation = true;
        this.$el.addClass('prices-location-table-selected');
        this._renderPricesTableCheck({selected: true});
      } else {
        this._renderPricesTableCheck({selected: false});
      }

  }
});


var OtherPricesCollectionView = BaseViews.CollectionView.extend({
  className: '',
  tagName: 'table',
  childView: OtherPricesItemView,
  childViewOptions: function(model, index) {
      var options = _.extend(
          { modelIndex: index },
          this.options
      );
      return options;
  }
});

var MenuItemPricesLocationTable = BaseViews.LayoutView.extend({
    className:
        'fmcy-menu-item-prices-location-table',
    template: require('./menu-item-prices-location-table/menu-item-prices-location-table.html'),
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                menuItemModel: null,
                variantCollection: null,
                locations: null,
                onSale: false,
                appChannel: null,
                filterLocation: null, //'hillsidevictoria'
                menuItemPriceLayoutSinglePrice: 'stacked',
                align: 'left',
                size: 'large', // default | large
                theme: 'default' // default | dark
            }
        );

        self.selectedLocationModel = self.options.locations.findWhere({ slug: self.options.filterLocation});

        this.options.locations = new Obscura(
            this.options.locations
        );

        this.options.locations.setSort(function(model) {
            if (model == self.selectedLocationModel) {
                return -1;
            } else {
              return 1;
            }
        });
    },
    ui: {
      selectedLocationPricesColumn: '.selected-location-prices-region-column'
    },
    regions: {
        selectedLocationTitleRegion: '.selected-location-title-region',
        selectedLocationPricesRegion: '.selected-location-prices-region',
        otherLocationPricesRegion: '.other-location-prices-region'
    },
    _renderLocationPrices: function () {
      var self = this;
      this._locationPrices = new MenuItemPrices({
        onlinePurchaseEnabled: true,
        menuItemModel: this.options.menuItemModel,
        collection: this.options.variantCollection,
        locations: this.options.locations,
        onSale: this.options.menuItemModel.isOnSale(),
        appChannel: this.options.appChannel,
        hideOutOfStockVariation: false,
        filterLocation: this.options.appChannel.request('get:filter:location'),
        menuItemPriceLayoutSinglePrice: this.options.menuItemPriceLayoutSinglePrice,
        align: this.options.align,
        size: this.options.size,
        theme: this.options.theme,
        variantShowInStockIfAtAnyLocation: false
      });
      this.selectedLocationPricesRegion.show(this._locationPrices);
    },
    _renderOtherLocationPrices: function () {
      this._otherLocationPrices = new OtherPricesCollectionView({
        menuItemModel: this.options.menuItemModel,
        collection: this.options.locations,
        selectedLocationModel: this.selectedLocationModel,
        variantCollection: this.options.variantCollection,
        filterLocation: this.options.filterLocation,
        appChannel: this.options.appChannel,
        menuItemPriceLayoutSinglePrice: this.options.menuItemPriceLayoutSinglePrice,
        align: this.options.align,
        size: this.options.size,
        theme: this.options.theme
      });
      this.otherLocationPricesRegion.show(this._otherLocationPrices);
    },
    _renderSelectedLocationPriceTable: function () {
        var self = this;
        this._renderLocationPrices();
        this._renderOtherLocationPrices();
    },
    onRender: function() {
        this._renderSelectedLocationPriceTable();
        // need to listen to global app change of filterLocation....
    }
});
module.exports = MenuItemPricesLocationTable;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/menu-item-prices-location-table.js
 **/